import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import SelectBox from '@welldev-group/rcl-select-box';
import { fetchCountryList, findCorrespondenceCountryLabel } from './countryListHelpers';

const CountrySelector = ({
  label,
  placeholderText,
  countryCode,
  setCountryCode,
  size,
  width,
  preFetchedCountryList,
  required,
  error,
  errorMsg,
  touched,
  isClearable,
}) => {
  const [countryList, setCountryList] = useState([]);

  useEffect(() => {
    if (preFetchedCountryList) {
      setCountryList(preFetchedCountryList);
    } else {
      fetchCountryList().then(list => setCountryList(list));
    }
  }, []);

  return (
    <SelectBox
      label={label}
      options={countryList}
      placeholderText={placeholderText}
      size={size}
      width={width}
      onChange={selectedOption => setCountryCode(selectedOption && selectedOption.value)}
      value={
        countryCode && {
          label: findCorrespondenceCountryLabel(countryList, countryCode),
          value: countryCode,
        }
      }
      errorMsg={errorMsg}
      touched={touched}
      required={required}
      error={error}
      isClearable={isClearable}
    />
  );
};

CountrySelector.defaultProps = {
  countryCode: null,
  size: 'tiny',
  width: 'full',
  preFetchedCountryList: null,
  placeholderText: null,
  required: false,
  errorMsg: '',
  touched: false,
  error: null,
  isClearable: true
};

CountrySelector.propTypes = {
  label: PropTypes.string.isRequired,
  placeholderText: PropTypes.string,
  countryCode: PropTypes.string,
  isClearable: PropTypes.bool,
  error: PropTypes.string,
  errorMsg: PropTypes.string,
  touched: PropTypes.bool,
  setCountryCode: PropTypes.func.isRequired,
  size: PropTypes.string,
  width: PropTypes.string,
  required: PropTypes.bool,
  preFetchedCountryList: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ),
};

export default CountrySelector;
